import { useState, useEffect } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { BarChart3 } from "lucide-react";
import { bonificacionIndicadores } from "@/api";

export default function IndicadoresBonificacion() {
  const [data, setData] = useState(null);

  useEffect(() => {
    bonificacionIndicadores().then(setData).catch(() => {});
  }, []);

  if (!data) return null;

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5" data-testid="indicadores-bonificacion">
      <h3 className="font-heading font-semibold text-municipal flex items-center gap-2 mb-4"><BarChart3 className="w-4 h-4" /> Indicadores</h3>
      <div className="grid sm:grid-cols-2 gap-6">
        <div>
          <p className="text-xs text-gray-500 mb-2">Evolución de ficheros generados (DNI con visitas / cumplen requisito)</p>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={data.evolucion_ficheros}>
              <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
              <XAxis dataKey="periodo" fontSize={11} />
              <YAxis fontSize={11} allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="total_dni" fill="#BD3742" name="DNI con visitas" radius={[4, 4, 0, 0]} />
              <Bar dataKey="total_cumple" fill="#009940" name="Cumplen requisito" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-2">Estado de verificación con el censo del Ayuntamiento</p>
          <ul className="space-y-2 mt-3">
            {Object.entries(data.estado_retorno_ayuntamiento).length === 0 && (
              <li className="text-sm text-gray-400">Aún no se ha subido ningún fichero de retorno.</li>
            )}
            {Object.entries(data.estado_retorno_ayuntamiento).map(([estado, count]) => (
              <li key={estado} className="flex justify-between text-sm border-b border-gray-50 pb-1.5">
                <span className="text-gray-600">{estado}</span>
                <span className="font-semibold text-municipal">{count}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
